import styled from 'styled-components';
import { breakpoint } from '../theme/breakpoint';
import { Card } from '../card-link/styles';

export const CardBanner = styled.div`
  display: flex;
  flex-flow: column;
  padding-top: ${({ theme }) => theme.spacing.medium};
  padding-bottom: ${({ theme }) => theme.spacing.xlarge};

  ${breakpoint.desktop`
    padding-top: 0;
    flex-flow: row;
    margin: ${({ theme }) => `0 -${theme.spacing.tiny}`};
  `};
`;

export const BannerBackground = styled.section`
  margin-bottom: ${({ theme, $removeMarginBottom }) =>
    $removeMarginBottom ? 0 : theme.spacing.large};
  background: ${({ theme }) => theme.palette.darkBackground};

  ${breakpoint.desktop`
    margin-top: ${({ theme }) => theme.spacing.xxlarge};
`};
`;

export const BannerText = styled.div`
  color: ${({ theme }) => theme.palette.white};
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 0 0 auto;

  ${breakpoint.desktop`
    flex: 1 1;
    flex-basis: ${({ theme }) => `calc(25% - ${theme.spacing.standard})`};
    margin: ${({ theme }) => `0 ${theme.spacing.tiny}`};
  `};
`;

export const CardRow = styled.div`
  display: flex;
  flex-flow: column;

  ${breakpoint.tablet`
    flex-flow: row;
    flex: 0 1 75%;
    margin-left: ${({ theme }) => `-${theme.spacing.tiny}`};
    margin-right: ${({ theme }) => `-${theme.spacing.tiny}`};

    > ${Card} {
      margin-left: ${({ theme }) => theme.spacing.tiny};
      margin-right: ${({ theme }) => theme.spacing.tiny};
      flex: 1 1 33%;
    }
  `};

  ${breakpoint.desktop`
      margin-left: 0;
      margin-right: 0;

      ${Card} {
        margin-top: ${({ theme }) => `-${theme.spacing.large}`};
      }
  `};
`;

export const HeaderText = styled.h2`
  margin-top: 0;
  margin-bottom: ${({ theme }) => theme.spacing.tiny};

  ${breakpoint.desktop`
    &::after {
      content: '';
      display: block;
      border-bottom: 1px solid ${({ theme }) => theme.palette.white};
      margin-left: ${({ theme }) => `-${theme.spacing.standard}`};
      padding-top: ${({ theme }) => theme.spacing.tiny};
    }
  `};
`;

export const SubHeaderText = styled.p`
  margin-bottom: ${({ theme }) => theme.spacing.standard};

  ${breakpoint.desktop`
    margin-bottom: ${({ theme }) => theme.spacing.small};
  `};
`;
